import { render, staticRenderFns } from "./AnnotationTermRow.vue?vue&type=template&id=4e15855c&scoped=true"
import script from "./AnnotationTermRow.vue?vue&type=script&lang=js"
export * from "./AnnotationTermRow.vue?vue&type=script&lang=js"
import style0 from "./AnnotationTermRow.vue?vue&type=style&index=0&id=4e15855c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e15855c",
  null
  
)

export default component.exports